<template>
    <div class="build-note">
        <p class="build-note__text">
            Your PC meets the minimum recommended specs to play VR games on the Oculus and HTC Vive.
        </p>
        <p class="build-note__text">
            Your PC will be capable of streaming most games in 720p with 60fps or better, provided your connection has at least 10mbps upload speed, and the streamed game typically runs at or above 60fps. Slower internet upload speeds may have mixed results.
        </p>
        <slot />
    </div>
</template>

<script>
export default {
    name: "BuildNote"
}
</script>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.build-note {
    @media (min-width: 769px) and (max-width: 991px) {
        padding: 0 15px;
    }

    &__text {
        color: $white;
        font-family: Akkurat-Light;
        font-size: 15px;
        font-weight: 300;
        line-height: 24px;
        margin-bottom: 35px;
    }

    &__link {
        text-transform: uppercase;
        color: $orchid;
        margin-bottom: 30px;
        letter-spacing: 1px;

        &:last-child {
            @media (max-width: 767px) {
                margin-bottom: 100px;
            }
        }
    }
}
</style>